import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IFolderSlice, IFolderContent } from '../../interfaces/Folder'
import { LOW_RISK, MEDIUM_RISK, STATUS } from '../../enums/common'
import {
  folderSaved,
  initialDataFailed,
  initialDataLoading,
  initialDataReceived,
} from '../actions'
import { setLoading } from '../reducers'
import { FolderDefaultState } from '../State/Folder'

const folderSlice = createSlice({
  name: 'folder',
  initialState: {
    status: STATUS.idle,
    folder: { ...FolderDefaultState },
    isMediumOrLowRisk: false,
  },
  reducers: {
    folderLoading: setLoading,
    folderReceived: (
      state: IFolderSlice,
      action: PayloadAction<Partial<IFolderContent>>
    ) => {
      return {
        ...state,
        folder: {
          ...state.folder,
          ...action.payload,
        },
      }
    },
    folderStatusIdle: (state: IFolderSlice) => {
      return {
        ...state,
        status: STATUS.idle,
      }
    },
    removeRevenues: (state: IFolderSlice) => {
      return {
        ...state,
        folder: {
          ...state.folder,
          revenue: [],
        },
      }
    },
    saveFolderFailed: (
      state: IFolderSlice,
      action: PayloadAction<Partial<IFolderContent>>
    ) => {
      return {
        ...state,
        folderError: { ...action.payload },
        status: STATUS.loaded,
      }
    },
    clearFolderError: (
      state: IFolderSlice,
      action: PayloadAction<{ field: keyof IFolderContent }>
    ) => {
      const newFolderError: Partial<IFolderContent> = { ...state.folderError }
      if (newFolderError && newFolderError[action.payload.field]) {
        delete newFolderError[action.payload.field]
      }

      return {
        ...state,
        folderError: newFolderError,
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(initialDataReceived, (state, action) => {
        if (state.status === STATUS.pending) {
          return {
            folder: {
              ...state.folder,
              ...action.payload[0],
              top_heb: action.payload[0]?.top_heb || '0',
            },
            status: STATUS.loaded,
            isMediumOrLowRisk: [MEDIUM_RISK, LOW_RISK].includes(
              action.payload[0].score_secu_fin
            ),
          }
        }

        return state
      })
      .addCase(initialDataLoading, setLoading)
      .addCase(initialDataFailed, (state) => {
        if (state.status === STATUS.pending) {
          return { ...state, status: STATUS.failed }
        }

        return state
      })
      .addCase(folderSaved, (state, action) => {
        if (state.status === STATUS.pending) {
          return {
            ...state,
            folder: {
              ...state.folder,
              ...action.payload.data,
            },
            status: STATUS.loaded,
          }
        }

        return state
      })
  },
})

const { actions, reducer } = folderSlice
export const folderActions = actions

export default reducer
